<template>
    <div :class="['popup', (show) ? 'show' : '']">
        <a href="#" class="close" @click="hide()">&times;</a>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "popup",
    props: [ "show" ],
    methods: {
        hide() {
            this.$emit("hide");
        }
    }
}
</script>
<style scoped>
    .popup {
        visibility: collapse;
        position: fixed;
        top: 25%;
        left: 12.5%;
        width: 75%;
        border: 2px solid #6c757d;
        box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.2);
        border-radius: 6px;
        opacity: 0;
        transition: all 0.2s ease-in-out; 
        transform: scale(0.8);
        background: #f8f9fa;
        color: #6c757d;
        padding: 2%;
    }
    .popup.show {
        z-index: 1000;
        visibility: visible;
        opacity: 1;
        transition: all 0.2s ease-in-out; 
        transform: scale(1.0);
    }
</style>